<div class="masonry-item flex-card clip6 position-relative prop-card fw-normal primary-border rounded-1 clip6-corner">
    <h6 class="mb-4 primary-text">No Data Found</h6>
</div>